import api from "../../../../api/axios";

export const fetchRooms = async () => {
  try {
    const response = await api.get(`pms/rooms`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rooms:", error);
    throw error;
  }
};

export const fetchReservations = async () => {
  try {
    const response = await api.get(`pms/reservations`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reservations", error);
    throw error;
  }
};
export const fetchRateTypes = async () => {
  try {
    const response = await api.get(`pms/rate-types`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reservations", error);
    throw error;
  }
};
export const createReservation = async (reservationData) => {
  try {
    const response = await api.post(`pms/reservations`, reservationData);
    return response.data;
  } catch (error) {
    console.error("Error creating reservation:", error);
    throw error;
  }
};

export const updateReservation = async (id, reservationData) => {
  try {
    const response = await api.put(`pms/reservations/${id}`, reservationData);
    return response.data;
  } catch (error) {
    console.error("Error updating reservation:", error);
    throw error;
  }
};

export const fetchCalendarData = async () => {
  try {
    const response = await api.get("pms/calendar/rooms");
    return response.data;
  } catch (error) {
    console.error("Error fetching calendar data:", error);
    throw error;
  }
};
